// Data Dosen
export const dataDosen = [
    {
        dosen_id: "DSN001",
        nidn: "0712058901",
        nama: "Dr. Citra Dewi, S.Kom., M.Cs.",
        email: "citra.dewi@asia.ac.id",
        no_hp: "081345678901",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        jabatan_fungsional: "Lektor Kepala",
        status: "Tetap",
        bidang_keahlian: "Artificial Intelligence, Machine Learning",
        alamat: "Jl. Sigura-gura No. 10, Malang",
        jenis_kelamin: "P",
        is_active: 1
    },
    {
        dosen_id: "DSN002",
        nidn: "0523067801",
        nama: "Prof. Dr. Ir. Hendro Wibowo, M.T.",
        email: "hendro.wibowo@asia.ac.id",
        no_hp: "081345678902",
        prodi_id: 3,
        prodi_nama: "Teknik Mesin",
        fakultas_id: 1,
        jabatan_fungsional: "Guru Besar",
        status: "Tetap",
        bidang_keahlian: "Mekanika Fluida, Termodinamika",
        alamat: "Jl. Semeru No. 25, Malang",
        jenis_kelamin: "L",
        is_active: 1
    },
    {
        dosen_id: "DSN003",
        nidn: "0615078501",
        nama: "Ir. Dedi Hartono, M.Kom.",
        email: "dedi.hartono@asia.ac.id",
        no_hp: "081345678903",
        prodi_id: 2,
        prodi_nama: "Sistem Informasi",
        fakultas_id: 3,
        jabatan_fungsional: "Lektor",
        status: "Tetap",
        bidang_keahlian: "Database, Enterprise Systems",
        alamat: "Jl. Kaliurang No. 15, Malang",
        jenis_kelamin: "L",
        is_active: 1
    },
    {
        dosen_id: "DSN004",
        nidn: "0728088001",
        nama: "Dr. Eko Prasetyo, S.T., M.T.",
        email: "eko.prasetyo@asia.ac.id",
        no_hp: "081345678904",
        prodi_id: 3,
        prodi_nama: "Teknik Mesin",
        fakultas_id: 1,
        jabatan_fungsional: "Lektor Kepala",
        status: "Tetap",
        bidang_keahlian: "Material Science, Manufacturing",
        alamat: "Jl. Arjuno No. 30, Malang",
        jenis_kelamin: "L",
        is_active: 1
    },
    {
        dosen_id: "DSN005",
        nidn: "0810079001",
        nama: "Ir. Fajar Nugroho, M.T.",
        email: "fajar.nugroho@asia.ac.id",
        no_hp: "081345678905",
        prodi_id: 4,
        prodi_nama: "Teknik Elektro",
        fakultas_id: 1,
        jabatan_fungsional: "Lektor",
        status: "Tetap",
        bidang_keahlian: "Power Systems, Electronics",
        alamat: "Jl. Bromo No. 45, Malang",
        jenis_kelamin: "L",
        is_active: 1
    },
    {
        dosen_id: "DSN006",
        nidn: "0912068201",
        nama: "Dr. Gita Permata, S.E., M.M.",
        email: "gita.permata@asia.ac.id",
        no_hp: "081345678906",
        prodi_id: 5,
        prodi_nama: "Manajemen",
        fakultas_id: 2,
        jabatan_fungsional: "Lektor Kepala",
        status: "Tetap",
        bidang_keahlian: "Strategic Management, Marketing",
        alamat: "Jl. Dieng No. 20, Malang",
        jenis_kelamin: "P",
        is_active: 1
    },
    {
        dosen_id: "DSN007",
        nidn: "1015078801",
        nama: "Hendra Wijaya, S.E., M.Ak.",
        email: "hendra.wijaya@asia.ac.id",
        no_hp: "081345678907",
        prodi_id: 6,
        prodi_nama: "Akuntansi",
        fakultas_id: 2,
        jabatan_fungsional: "Lektor",
        status: "Tetap",
        bidang_keahlian: "Financial Accounting, Auditing",
        alamat: "Jl. Panderman No. 35, Malang",
        jenis_kelamin: "L",
        is_active: 1
    },
    {
        dosen_id: "DSN008",
        nidn: "1118089101",
        nama: "Indah Kusuma, S.Kom., M.Kom.",
        email: "indah.kusuma@asia.ac.id",
        no_hp: "081345678908",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        jabatan_fungsional: "Asisten Ahli",
        status: "Tetap",
        bidang_keahlian: "Web Development, UI/UX Design",
        alamat: "Jl. Candi No. 50, Malang",
        jenis_kelamin: "P",
        is_active: 1
    },
    {
        dosen_id: "DSN009",
        nidn: "1220089201",
        nama: "Joko Santoso, S.Kom., M.T.",
        email: "joko.santoso@asia.ac.id",
        no_hp: "081345678909",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        jabatan_fungsional: "Asisten Ahli",
        status: "Tetap",
        bidang_keahlian: "Network Security, Cloud Computing",
        alamat: "Jl. Tidar No. 60, Malang",
        jenis_kelamin: "L",
        is_active: 1
    },
    {
        dosen_id: "DSN010",
        nidn: "0105067501",
        nama: "Dr. Siti Rahayu, S.E., M.M.",
        email: "siti.rahayu@asia.ac.id",
        no_hp: "081345678910",
        prodi_id: 5,
        prodi_nama: "Manajemen",
        fakultas_id: 2,
        jabatan_fungsional: "Lektor Kepala",
        status: "Tetap",
        bidang_keahlian: "Human Resource Management, Organizational Behavior",
        alamat: "Jl. Galunggung No. 70, Malang",
        jenis_kelamin: "P",
        is_active: 1
    }
];

// Dosen Non-Tetap
export const dataDosenNonTetap = [
    {
        dosen_id: "DSNT001",
        nidn: null,
        nama: "Kartika Sari, S.Kom., M.Kom.",
        email: "kartika.sari@asia.ac.id",
        no_hp: "081456789001",
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        fakultas_id: 3,
        jabatan_fungsional: null,
        status: "Non-Tetap",
        bidang_keahlian: "Mobile Development",
        alamat: "Jl. Raya Malang No. 100",
        jenis_kelamin: "P",
        is_active: 1
    },
    {
        dosen_id: "DSNT002",
        nidn: null,
        nama: "Lukman Hakim, S.T., M.Eng.",
        email: "lukman.hakim@asia.ac.id",
        no_hp: "081456789002",
        prodi_id: 3,
        prodi_nama: "Teknik Mesin",
        fakultas_id: 1,
        jabatan_fungsional: null,
        status: "Non-Tetap",
        bidang_keahlian: "CAD/CAM",
        alamat: "Jl. Raya Batu No. 50",
        jenis_kelamin: "L",
        is_active: 1
    }
];

export const dropdownDosen = dataDosen.map(d => ({
    value: d.dosen_id,
    label: d.nama
}));

export default dataDosen;
